"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./PullQuote.scss");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _generateID = _interopRequireDefault(require("../../utils/generateID"));
var _checkForDangerouslySet = _interopRequireDefault(require("../../utils/checkForDangerouslySet"));
var _checkForThemeProps = require("../../utils/checkForThemeProps");
var _useStyles = _interopRequireDefault(require("../../utils/hooks/useStyles"));
var _generateFocusedImageAlt = _interopRequireDefault(require("../../utils/generateFocusedImageAlt"));
var _formatSpecialCharText = _interopRequireDefault(require("../../utils/formatSpecialCharText"));
var _renderImageOrLottieAnimation = require("../../utils/renderImageOrLottieAnimation");
var _Video = _interopRequireDefault(require("../Video/Video"));
var _Button = _interopRequireDefault(require("../Button/Button"));
var _FocusedImage = _interopRequireDefault(require("../FocusedImage/FocusedImage"));
var _LottieAnimation = _interopRequireDefault(require("../LottieAnimation/LottieAnimation"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const imageSizes = {
  "variant1_1/4": {
    desktop: {
      width: 240,
      height: 240,
      ratio: {
        width: 1,
        height: 1
      }
    },
    tablet: {
      width: 240,
      height: 240,
      ratio: {
        width: 1,
        height: 1
      }
    },
    mobile: {
      width: 240,
      height: 240,
      ratio: {
        width: 1,
        height: 1
      }
    }
  },
  "variant2_1/4": {
    desktop: {
      width: 600,
      height: 870,
      ratio: {
        width: 20,
        height: 29
      }
    },
    tablet: {
      width: 380,
      height: 684,
      ratio: {
        width: 2,
        height: 9
      }
    },
    mobile: {
      width: 640,
      height: 480,
      ratio: {
        height: 3,
        width: 4
      }
    }
  },
  "variant2_1/2": {
    desktop: {
      width: 720,
      height: 720,
      ratio: {
        width: 1,
        height: 1
      }
    },
    tablet: {
      width: 720,
      height: 480,
      ratio: {
        width: 7,
        height: 3
      }
    },
    mobile: {
      width: 360,
      height: 240,
      ratio: {
        width: 3,
        height: 1.5
      }
    }
  },
  variant3: {
    desktop: {
      width: 800,
      height: 400,
      ratio: {
        width: 8,
        height: 3
      }
    },
    tablet: {
      width: 800,
      height: 400,
      ratio: {
        width: 8,
        height: 4
      }
    },
    mobile: {
      width: 320,
      height: 200,
      ratio: {
        width: 3,
        height: 2
      }
    }
  },
  nested: {
    desktop: {
      width: 720,
      height: 720,
      ratio: {
        width: 1,
        height: 1
      }
    },
    tablet: {
      width: 720,
      height: 720,
      ratio: {
        width: 1,
        height: 1
      }
    },
    mobile: {
      width: 600,
      height: 600,
      ratio: {
        width: 1,
        height: 1
      }
    }
  }
};
const PullQuote = props => {
  const {
    content = {},
    zIndex,
    id,
    variant,
    nestedInTab = false,
    height
  } = props;
  const wrapper = (0, _react.useRef)(null);
  const themes = (0, _checkForThemeProps.checkForThemeProps)(content?.theme);
  const {
    backgroundColor,
    color
  } = (0, _useStyles.default)(themes);
  const {
    quote: quoteObj,
    topImage,
    sideImage,
    imagePosition,
    appearance,
    backgroundImage,
    imageOptions,
    contentfulId
  } = content;
  const {
    text: quoteText,
    source: quoteSource,
    sourceTitle: quoteSourceTitle
  } = quoteObj;
  const isTopImage = topImage?.focalPointImage?.url || topImage?.src ? true : false;
  const isSideImage = sideImage?.focalPointImage?.url || sideImage?.src ? true : false;
  const hasBackgroundImage = backgroundImage?.focalPointImage?.url || backgroundImage?.src ? true : false;
  const pictureStyles = () => {
    if (variant === "variant1") {
      return {
        borderRadius: "50%",
        border: "4px solid white",
        boxShadow: "0 0 0 2px #fbad26",
        boxSizing: "content-box"
      };
    }
    if (variant === "variant2") {
      return {
        height: "100%"
      };
    }
    return null;
  };
  const imageContainerOption = {
    "1/4": "25%",
    "1/2": "50%",
    "No Image": "100%"
  };
  const quoteContainerOption = {
    "1/4": "75%",
    "1/2": "50%",
    "No Image": "100%"
  };
  const containerWidthClass = {
    "25%": "quarter",
    "50%": "half",
    "75%": "threeQuarter",
    "100%": "full"
  };
  const lottieStyles = {
    height: "100%"
  };
  const lottieStylesBackground = {
    height: "100vh"
  };
  const backgroundImageComponent = () => {
    if (backgroundImage?.type === "lottieAnimation") {
      return /*#__PURE__*/_react.default.createElement(_LottieAnimation.default, {
        src: backgroundImage?.src,
        style: {
          ...backgroundImage?.style,
          ...lottieStylesBackground
        },
        ratio: {
          width: 4,
          height: 3
        }
      });
    } else {
      return /*#__PURE__*/_react.default.createElement("img", {
        src: backgroundImage?.focalPointImage?.url,
        alt: backgroundImage?.focalPointImage?.title ? backgroundImage?.focalPointImage?.title : "",
        className: "ter-pullQuote__background--image"
      });
    }
  };
  const renderPullQuoteContent = () => {
    return /*#__PURE__*/_react.default.createElement("section", {
      className: `ter-pullQuote__quote-section__quote ter-pullQuote__quote-section__quote--${variant?.toLowerCase()}--${containerWidthClass[quoteContainerOption[imageOptions]]}`
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: `ter-pullQuote__full-quote-wrapper ter-pullQuote__full-quote-wrapper--${appearance?.toLowerCase()}`
    }, /*#__PURE__*/_react.default.createElement("aside", {
      className: "ter-pullQuote__full-quote-wrapper--content"
    }, quoteText && !(0, _checkForDangerouslySet.default)(quoteText) && /*#__PURE__*/_react.default.createElement("p", {
      className: "ter-pullQuote__quote-text",
      style: {
        color: color
      },
      dangerouslySetInnerHTML: (0, _formatSpecialCharText.default)(quoteText),
      "data-sb-field-path": contentfulId ? "quote" : null
    }), quoteText && (0, _checkForDangerouslySet.default)(quoteText) && /*#__PURE__*/_react.default.createElement("div", {
      className: "ter-pullQuote__quote-text-holder dangerously-set-content",
      dangerouslySetInnerHTML: (0, _formatSpecialCharText.default)(quoteText),
      "data-sb-field-path": contentfulId ? "quote" : null
    }), quoteSource && /*#__PURE__*/_react.default.createElement("p", {
      className: "ter-pullQuote__quote-source",
      style: {
        color: color
      },
      "data-sb-field-path": contentfulId ? "author" : null
    }, quoteSource), quoteSourceTitle && /*#__PURE__*/_react.default.createElement("p", {
      className: "ter-pullQuote__quote-source-title",
      style: {
        color: color
      },
      "data-sb-field-path": contentfulId ? "authorCredentials" : null
    }, quoteSourceTitle), (content?.cta?.url && content?.cta?.text || content?.cta?.onClick && content?.cta?.text || content?.cta?.text && content?.cta?.video) && /*#__PURE__*/_react.default.createElement(_Button.default, {
      contentfulId: content?.cta?.contentfulId,
      Link: content?.Link,
      url: content?.cta?.url,
      text: content?.cta?.text,
      className: `ter-button--${content?.cta?.className}` || "ter-button--primary--2",
      external: content?.external,
      VideoComponent: _Video.default ? _Video.default : null,
      video: content?.cta?.video ? content?.cta?.video : null,
      setOverride: content?.cta?.setOverride ? content?.cta?.setOverride : null,
      override: content?.cta?.override ? content?.cta?.override : null,
      onClick: content?.cta?.onClick
    }))));
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: hasBackgroundImage ? "ter-pullQuote__grid" : ""
  }, hasBackgroundImage && /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-pullQuote__background"
  }, backgroundImageComponent()), /*#__PURE__*/_react.default.createElement("section", {
    className: `ter-pullQuote ter-pullQuote--${variant} ter-pullQuote--color-${appearance?.toLowerCase()} ${hasBackgroundImage ? "ter-pullQuote--background-layout" : ""}`,
    "data-sb-object-id": contentfulId ? contentfulId : null,
    style: {
      zIndex: zIndex + 1 || "auto",
      height: height ? height : "auto"
    }
    // id={generateID(id, content.header)}
    ,
    ref: wrapper
  }, isTopImage && !imageOptions?.includes("No Image") && /*#__PURE__*/_react.default.createElement("section", {
    className: `ter-pullQuote ter-pullQuote--top-image`,
    "data-sb-field-path": contentfulId ? "topImage" : null
  }, (0, _renderImageOrLottieAnimation.renderImageOrLottieAnimation)(topImage, pictureStyles(), imageSizes?.variant3, (0, _generateFocusedImageAlt.default)(topImage), "ter-pullQuote__top-image", lottieStyles, true, {
    width: 14,
    height: 5
  })), /*#__PURE__*/_react.default.createElement("section", {
    style: {
      backgroundColor: backgroundColor,
      color: color
    },
    "data-sb-object-id": contentfulId ? contentfulId : null,
    className: `ter-pullQuote ter-pullQuote__quote-section ter-pullQuote__quote-section--${variant?.toLowerCase()}--${containerWidthClass[imageContainerOption[imageOptions]]} ter-pullQuote__quote-section--${appearance?.toLowerCase()} ${!imageOptions?.includes("No Image") && imagePosition ? `ter-pullQuote__quote-section--${imagePosition?.toLowerCase()}` : null}
        `
  }, !isTopImage && isSideImage && /*#__PURE__*/_react.default.createElement("section", {
    className: `ter-pullQuote__quote-section__image ter-pullQuote__quote-section__image--${variant?.toLowerCase()}--${containerWidthClass[imageContainerOption[imageOptions]]} ter-pullQuote__quote-section__image--${variant?.toLowerCase()}--${imagePosition?.toLowerCase()}
                ${nestedInTab === true ? 'ter-pullQuote__quote-section__image--nested-in-tab' : ''}
              `,
    "data-sb-field-path": contentfulId ? "sideImage" : null
  }, (0, _renderImageOrLottieAnimation.renderImageOrLottieAnimation)(sideImage, pictureStyles(), imageSizes[nestedInTab === true ? `nested` : `${variant}_${imageOptions}`], (0, _generateFocusedImageAlt.default)(sideImage), "ter-pullQuote__side-image", lottieStyles, false, {
    height: 1,
    width: 1
  }, contentfulId)), renderPullQuoteContent())));
};
var _default = PullQuote;
exports.default = _default;
PullQuote.propTypes = {
  content: _propTypes.default.shape({
    image: _propTypes.default.shape({
      url: _propTypes.default.string,
      altText: _propTypes.default.string
    }),
    quote: _propTypes.default.shape({
      text: _propTypes.default.string.isRequired,
      source: _propTypes.default.string,
      sourceTitle: _propTypes.default.string
    }).isRequired,
    cta: _propTypes.default.shape({
      url: _propTypes.default.string,
      text: _propTypes.default.string.isRequired
    })
  }),
  nestedInTab: _propTypes.default.bool
};